export const pickSuggestedCountry = ({
  visitorCountry,
  storeCountryCode,
  availableCountryCodes,
}: {
  visitorCountry: string | null;
  storeCountryCode: string;
  availableCountryCodes: string[];
}): string | null => {
  if (!visitorCountry) {
    return null;
  }

  const visitor = visitorCountry.trim().toUpperCase();
  const store = storeCountryCode.trim().toUpperCase();

  if (!visitor || visitor === store) {
    return null;
  }

  const hasOwnStore = availableCountryCodes.some(
    (code) => code.trim().toUpperCase() === visitor,
  );

  return hasOwnStore ? visitor : null;
};
